import type { ApiClient } from '@treneo/infrastructure/api';
import { BaseApi } from '@treneo/infrastructure/api';
import type {
  ICurrentUserInfoResponse,
  ISaveAreTipsHiddenRequest,
  ISaveCurrentUserInfoRequest,
  ISaveIsMachineBarPinnedRequest,
  ISaveIsStartBannerHiddenRequest,
  ISaveLanguageCodeRequest,
  ISaveThemeRequest,
  ISaveTimezoneRequest,
  Result
} from '@treneo/models';
import { API_PATHS } from '@treneo/shared/constants';

let inFlightGetCurrentUser: Promise<Result<ICurrentUserInfoResponse>> | null = null;

export class UsersApi extends BaseApi {
  protected readonly baseUrl = API_PATHS.USERS_PREFIX;

  constructor(apiClient: ApiClient) {
    super(apiClient);
  }

  getCurrentUser = (includePermissions = true): Promise<Result<ICurrentUserInfoResponse>> => {
    if (inFlightGetCurrentUser !== null) {
      return inFlightGetCurrentUser;
    }

    const queryParams = includePermissions ? '?includePermissions=true' : '';
    const promise = this.get<ICurrentUserInfoResponse>(
      `/current${queryParams}`,
      null,
      'Get user failed'
    )
      .then(result => {
        inFlightGetCurrentUser = null;
        return result;
      })
      .catch(error => {
        inFlightGetCurrentUser = null;
        throw error;
      });

    inFlightGetCurrentUser = promise;
    return promise;
  };

  saveCurrentUserInfo = (request: ISaveCurrentUserInfoRequest): Promise<void> =>
    this.patchVoid('/current', request);

  saveTheme = (request: ISaveThemeRequest): Promise<void> =>
    this.patchVoid('/current/theme', request);

  saveLanguageCode = (request: ISaveLanguageCodeRequest): Promise<void> =>
    this.patchVoid('/current/language-code', request);

  saveTimezone = (request: ISaveTimezoneRequest): Promise<void> =>
    this.patchVoid('/current/timezone', request);

  saveAreTipsHidden = (request: ISaveAreTipsHiddenRequest): Promise<void> =>
    this.patchVoid('/current/tips-hidden', request);

  saveIsMachineBarPinned = (request: ISaveIsMachineBarPinnedRequest): Promise<void> =>
    this.patchVoid('/current/machine-bar-pinned', request);

  saveIsStartBannerHidden = (request: ISaveIsStartBannerHiddenRequest): Promise<void> =>
    this.patchVoid('/current/start-banner-hidden', request);
}
